"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var geostyler_cql_parser_1 = require("geostyler-cql-parser");
var _get = require('lodash/get');
var _set = require('lodash/set');
var _isEqual = require('lodash/isEqual');
var _cloneDeep = require('lodash/cloneDeep');
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../locale/en_US"));
require("./RuleTable.css");
var Renderer_1 = __importDefault(require("../Symbolizer/Renderer/Renderer"));
var FilterEditorWindow_1 = __importDefault(require("../Filter/FilterEditorWindow/FilterEditorWindow"));
var SymbolizerEditorWindow_1 = __importDefault(require("../Symbolizer/SymbolizerEditorWindow/SymbolizerEditorWindow"));
var FilterUtil_1 = __importDefault(require("../../Util/FilterUtil"));
var SLDRenderer_1 = require("../Symbolizer/SLDRenderer/SLDRenderer");
var DataUtil_1 = __importDefault(require("../../Util/DataUtil"));
var RuleReorderButtons_1 = __importDefault(require("./RuleReorderButtons/RuleReorderButtons"));
var RuleTable = /** @class */ (function (_super) {
    __extends(RuleTable, _super);
    function RuleTable(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The Parser to read and write CQL Filter
         *
         */
        _this.cqlParser = new geostyler_cql_parser_1.CqlParser();
        _this.getRuleRecords = function () {
            var rules = _this.props.rules;
            return rules.map(function (rule, index) {
                return __assign({ key: index }, rule);
            });
        };
        _this.onSymbolizerClick = function (record, symbolizerEditorPosition) {
            _this.setState({
                ruleEditIndex: record.key,
                symbolizerEditorVisible: true,
                symbolizerEditorPosition: symbolizerEditorPosition,
                filterEditorVisible: false
            });
        };
        _this.symbolizerRenderer = function (text, record) {
            var _a = _this.props, data = _a.data, rendererType = _a.rendererType, sldRendererProps = _a.sldRendererProps;
            var onSymbolizerClick = function (symbolizers, event) {
                var filterPosition = event.target.getBoundingClientRect();
                _this.onSymbolizerClick(record, filterPosition);
            };
            return (rendererType === 'SLD' ? (React.createElement(SLDRenderer_1.SLDRenderer, __assign({ symbolizers: record.symbolizers, onClick: onSymbolizerClick }, sldRendererProps))) : (React.createElement(Renderer_1.default, { symbolizers: record.symbolizers, onClick: onSymbolizerClick, data: data })));
        };
        _this.nameRenderer = function (text, record) {
            var locale = _this.props.locale;
            var input = (React.createElement(antd_1.Input, { value: record.name, onChange: function (event) {
                    var target = event.target;
                    _this.setValueForRule(record.key, 'name', target.value);
                } }));
            return (React.createElement(antd_1.Popover, { content: record.name, title: locale.nameColumnTitle }, input));
        };
        _this.filterRenderer = function (text, record) {
            var locale = _this.props.locale;
            var cqlParser = _this.cqlParser;
            var cql = cqlParser.write(record.filter);
            var filterCell;
            var inputSearch = (React.createElement(antd_1.Input.Search, { className: "gs-rule-table-filter-cell", value: cql, onChange: function (event) {
                    // TODO The CQL representation is currently not editable
                    // const value = event.target.value;
                    // try {
                    //   const newFilter = FilterUtil.readFromCql(value);
                    //   this.setValueForRule(record.key, 'filter', newFilter);
                    // } catch (error) {
                    //   // TODO Feedback
                    // }
                }, enterButton: (React.createElement(antd_1.Icon, { type: "edit" })), onSearch: function (value, event) {
                    var filterPosition = event.target.getBoundingClientRect();
                    _this.onFilterEditClick(record.key, filterPosition);
                } }));
            if (cql && cql.length > 0) {
                filterCell = (React.createElement(antd_1.Popover, { content: cql, title: locale.filterColumnTitle }, inputSearch));
            }
            else {
                filterCell = inputSearch;
            }
            return filterCell;
        };
        _this.onFilterEditClick = function (ruleEditIndex, filterEditorPosition) {
            _this.setState({
                ruleEditIndex: ruleEditIndex,
                filterEditorPosition: filterEditorPosition,
                symbolizerEditorVisible: false,
                filterEditorVisible: true
            });
        };
        _this.minScaleRenderer = function (text, record) {
            var minScaleDenominator = _get(record, 'scaleDenominator.min');
            var value = minScaleDenominator ? parseFloat(minScaleDenominator) : undefined;
            return (React.createElement(antd_1.InputNumber, { className: "scale-denominator min-scale-denominator", value: value, min: 0, formatter: function (val) { return val ? "1:" + val : ''; }, parser: function (val) { return parseFloat(val.replace('1:', '')); }, onChange: function (newValue) {
                    _this.setValueForRule(record.key, 'scaleDenominator.min', newValue);
                } }));
        };
        _this.maxScaleRenderer = function (text, record) {
            var maxScaleDenominator = _get(record, 'scaleDenominator.max');
            var value = maxScaleDenominator ? parseFloat(maxScaleDenominator) : undefined;
            return (React.createElement(antd_1.InputNumber, { className: "scale-denominator max-scale-denominator", value: value, min: 0, formatter: function (val) { return val ? "1:" + val : ''; }, parser: function (val) { return parseFloat(val.replace('1:', '')); }, onChange: function (newValue) {
                    _this.setValueForRule(record.key, 'scaleDenominator.max', newValue);
                } }));
        };
        _this.amountRenderer = function (text, record) {
            var data = _this.props.data;
            var amount = '-';
            var filter = record.filter;
            if (data && filter) {
                try {
                    amount = _this.state.counts[record.key];
                }
                catch (error) {
                    amount = '-';
                }
            }
            else if (data && DataUtil_1.default.isVector(data)) {
                amount = data.exampleFeatures.features.length;
            }
            return (React.createElement("div", { className: "ant-input gs-rule-table-numeric-cell" }, amount));
        };
        _this.duplicatesRenderer = function (text, record) {
            var _a = _this.props, data = _a.data, rules = _a.rules;
            var duplicates = '-';
            if (data && rules) {
                try {
                    duplicates = _this.state.duplicates[record.key];
                }
                catch (error) {
                    duplicates = '-';
                }
            }
            return (React.createElement("div", { className: "ant-input gs-rule-table-numeric-cell" }, duplicates));
        };
        _this.ruleReorderRenderer = function (record) {
            var _a = _this.props, rules = _a.rules, onRulesChange = _a.onRulesChange;
            return (React.createElement(RuleReorderButtons_1.default, { ruleIndex: record.key, rules: rules, onRulesMove: onRulesChange }));
        };
        _this.onSymbolizersChange = function (symbolizers) {
            var ruleEditIndex = _this.state.ruleEditIndex;
            _this.setValueForRule(ruleEditIndex, 'symbolizers', symbolizers);
        };
        _this.onFilterChange = function (filter) {
            var ruleEditIndex = _this.state.ruleEditIndex;
            _this.setValueForRule(ruleEditIndex, 'filter', filter);
        };
        _this.setValueForRule = function (ruleIndex, key, value) {
            var _a = _this.props, onRulesChange = _a.onRulesChange, rules = _a.rules;
            var rulesClone = _cloneDeep(rules);
            _set(rulesClone[ruleIndex], key, value);
            if (onRulesChange) {
                onRulesChange(rulesClone);
            }
        };
        _this.onSymbolizerEditorWindowClose = function () {
            _this.setState({
                symbolizerEditorVisible: false
            });
        };
        _this.onFilterEditorWindowClose = function () {
            _this.setState({
                filterEditorVisible: false
            });
        };
        _this.getColumns = function () {
            var _a = _this.props, locale = _a.locale, showAmountColumn = _a.showAmountColumn, showDuplicatesColumn = _a.showDuplicatesColumn;
            var columns = [{
                    dataIndex: '',
                    width: 70,
                    render: _this.ruleReorderRenderer
                },
                {
                    title: (React.createElement(antd_1.Tooltip, { title: locale.symbolizersColumnTitle },
                        React.createElement(antd_1.Icon, { type: "bg-colors" }))),
                    dataIndex: 'symbolizers',
                    render: _this.symbolizerRenderer
                }, {
                    title: locale.nameColumnTitle,
                    dataIndex: 'name',
                    render: _this.nameRenderer
                }, {
                    title: locale.filterColumnTitle,
                    dataIndex: 'filter',
                    render: _this.filterRenderer
                }, {
                    title: locale.minScaleColumnTitle,
                    dataIndex: 'minScale',
                    render: _this.minScaleRenderer
                }, {
                    title: locale.maxScaleColumnTitle,
                    dataIndex: 'maxScale',
                    render: _this.maxScaleRenderer
                }];
            if (showAmountColumn) {
                columns.push({
                    title: (React.createElement(antd_1.Tooltip, { title: locale.amountColumnTitle }, "\u03A3")),
                    dataIndex: 'amount',
                    render: _this.amountRenderer
                });
            }
            if (showDuplicatesColumn) {
                columns.push({
                    title: (React.createElement(antd_1.Tooltip, { title: locale.duplicatesColumnTitle },
                        React.createElement(antd_1.Icon, { type: "block" }))),
                    dataIndex: 'duplicates',
                    render: _this.duplicatesRenderer
                });
            }
            return columns;
        };
        _this.state = {
            ruleEditIndex: undefined,
            symbolizerEditorVisible: false,
            symbolizerEditorPosition: undefined,
            filterEditorVisible: false,
            filterEditorPosition: undefined,
            hasError: false,
            data: undefined,
            rules: undefined,
            counts: undefined,
            duplicates: undefined
        };
        return _this;
    }
    RuleTable.getDerivedStateFromProps = function (nextProps, prevState) {
        var countsAndDuplicates;
        try {
            var filtersEqual_1 = true;
            nextProps.rules.forEach(function (rule, index) {
                try {
                    filtersEqual_1 = filtersEqual_1 && _isEqual(prevState.rules[index].filter, rule.filter);
                }
                catch (e) {
                    filtersEqual_1 = false;
                }
            });
            // we should refrain from using _isEqual on the data as it's very slow on largish datasets
            // thus it's the responsibility of the calling code to make sure the object only gets updated when actual data
            // changes
            if (filtersEqual_1 && nextProps.data === prevState.data) {
                return {};
            }
            if (nextProps.data && DataUtil_1.default.isVector(nextProps.data)) {
                countsAndDuplicates = FilterUtil_1.default.calculateCountAndDuplicates(nextProps.rules, nextProps.data);
            }
            else {
                countsAndDuplicates = {};
            }
        }
        catch (e) {
            // make sure to update state when checks/calculation fails
        }
        return {
            data: nextProps.data,
            rules: nextProps.rules,
            counts: countsAndDuplicates.counts,
            duplicates: countsAndDuplicates.duplicates
        };
    };
    RuleTable.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    RuleTable.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    RuleTable.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement("h1", null, "An error occured in the RuleTable UI.");
        }
        var _a = this.props, locale = _a.locale, rules = _a.rules, filterUiProps = _a.filterUiProps, data = _a.data, iconLibraries = _a.iconLibraries, showAmountColumn = _a.showAmountColumn, showDuplicatesColumn = _a.showDuplicatesColumn, colorRamps = _a.colorRamps, restProps = __rest(_a, ["locale", "rules", "filterUiProps", "data", "iconLibraries", "showAmountColumn", "showDuplicatesColumn", "colorRamps"]);
        var _b = this.state, ruleEditIndex = _b.ruleEditIndex, symbolizerEditorVisible = _b.symbolizerEditorVisible, symbolizerEditorPosition = _b.symbolizerEditorPosition, filterEditorVisible = _b.filterEditorVisible, filterEditorPosition = _b.filterEditorPosition;
        return (React.createElement("div", null,
            React.createElement(antd_1.Table, __assign({ className: "gs-rule-table", columns: this.getColumns(), dataSource: this.getRuleRecords(), pagination: false }, restProps)),
            !symbolizerEditorVisible ? null :
                React.createElement(SymbolizerEditorWindow_1.default, { x: symbolizerEditorPosition
                        ? symbolizerEditorPosition.x + symbolizerEditorPosition.width
                        : undefined, y: symbolizerEditorPosition ? symbolizerEditorPosition.y : undefined, onClose: this.onSymbolizerEditorWindowClose, internalDataDef: data, symbolizers: rules[ruleEditIndex].symbolizers, onSymbolizersChange: this.onSymbolizersChange, iconLibraries: iconLibraries, colorRamps: colorRamps }),
            !filterEditorVisible ? null :
                React.createElement(FilterEditorWindow_1.default, { x: filterEditorPosition ? filterEditorPosition.x : undefined, y: filterEditorPosition
                        ? filterEditorPosition.y + filterEditorPosition.height
                        : undefined, onClose: this.onFilterEditorWindowClose, filter: rules[ruleEditIndex].filter, onFilterChange: this.onFilterChange, filterUiProps: filterUiProps, internalDataDef: data && DataUtil_1.default.isVector(data) ? data : undefined })));
    };
    RuleTable.componentName = 'RuleTable';
    RuleTable.defaultProps = {
        locale: en_US_1.default.GsRuleTable,
        rendererType: 'OpenLayers',
        showAmountColumn: true,
        showDuplicatesColumn: true
    };
    return RuleTable;
}(React.Component));
exports.RuleTable = RuleTable;
exports.default = LocaleWrapper_1.localize(RuleTable, RuleTable.componentName);
//# sourceMappingURL=RuleTable.js.map